import {
    Endpoint as AuthEndpoint,
} from '@amzn/awscat-portal-authentication-library';
  
export interface FrontendEnvironment {
    region: string;
    portalClient: string;
    portalClientId: string;
    backendEnvironment: Environment;
    rumConfig?: RumConfig;
  }
  
export interface EnvironmentConfig {
    environment: Environment;
    region: string;
    portalClient: string;
    portalClientId: string;
    backendEnvironment: Environment;
    authEndpoint: AuthEndpoint;
    rumConfig?: RumConfig;
  }

export interface RumConfig {
    appId: string;
    identityPoolId: string;
    guestRoleArn: string;
    region: string;
  }
  
export enum Environment {
    localdev = 'localdev',
    beta = 'beta',
    gamma = 'gamma',
    prod = 'prod',
  }

const authEndpointMap: { [key in keyof typeof Environment]: AuthEndpoint } = {
    localdev: {
        url: 'https://portal.localdev.mpa.accelerate.proserve.aws.dev',
        name: 'localdev',
    },
    beta: {
        url: 'https://portal.beta.mpa.accelerate.proserve.aws.dev',
        name: 'beta'
    },
    gamma: {
        url: 'https://portal.gamma.mpa.accelerate.proserve.aws.dev',
        name: 'gamma'
    },
    prod: {
        url: 'https://accelerate.amazonaws.com',
        name: 'prod',
    }
};
  
const environmentMap: { [key in keyof typeof Environment]: FrontendEnvironment } = {
    localdev: {
        // Dev is using Beta backend normally
        region: 'us-west-2',
        portalClient: 'mpa-localdev',
        portalClientId: 'TBD', // cat-users:mpa-localdev
        backendEnvironment: Environment.beta,
        // Rum dashboard for local testing - uncomment when testing RUM events
        // rumConfig: {
        //     appId: '732473fd-2226-433a-b38c-b8350c28b9c0',
        //     identityPoolId: 'us-east-1:d90b8afe-3132-4b8e-8c55-c30962cd8ef4',
        //     guestRoleArn: 'arn:aws:iam::389825484903:role/RUM-Monitor-us-east-1-389825484903-PortfolioTool-Unauth',
        //     region: 'us-east-1',
        // }
    },
    beta: {
        region: 'us-west-2',
        portalClient: 'mpa',
        portalClientId: 'TBD', // cat-users:mpa
        backendEnvironment: Environment.beta,
        rumConfig: {
            appId: '434d4693-3919-46a1-98e4-10cf7f456543',
            identityPoolId: 'us-east-1:d90b8afe-3132-4b8e-8c55-c30962cd8ef4',
            guestRoleArn: 'arn:aws:iam::389825484903:role/RUM-Monitor-us-east-1-389825484903-PortfolioTool-Unauth',
            region: 'us-east-1',
        }
    },
    gamma: {
        region: 'us-west-2',
        portalClient: 'mpa',
        portalClientId: 'TBD', // cat-users:mpa
        backendEnvironment: Environment.gamma,
        rumConfig: {
            appId: 'ad835b74-6569-475f-a6d9-b79eb39a578a',
            identityPoolId: 'us-east-1:5f8e64e1-c497-48d2-8421-37731a9f9eca',
            guestRoleArn: 'arn:aws:iam::421962412581:role/RUM-Monitor-us-east-1-421962412581-PortfolioTool-Unauth',
            region: 'us-east-1',
        },
    },
    prod: {
        // TODO: Complete PROD details once known.
        region: 'us-west-2',
        portalClient: 'mpa',
        portalClientId: 'TBD',
        backendEnvironment: Environment.prod,
        rumConfig: {
            appId: '7815a0ab-649d-4bd0-8fe6-df26e8ae65ce',
            identityPoolId: 'us-east-1:e2fe45e0-f818-44f0-908b-be93f77e460f',
            guestRoleArn: 'arn:aws:iam::550572405293:role/RUM-Monitor-us-east-1-550572405293-PortfolioTool-Unauth',
            region: 'us-east-1',
        },
    },
};
  
export const GetEnvironment = (): Environment => {
    switch (window.location.hostname) {
        case 'beta.mpa.accelerate.proserve.aws.dev':
            return Environment.beta;
        case 'gamma.mpa.accelerate.proserve.aws.dev':
            return Environment.gamma;
        case 'mpa.accelerate.amazonaws.com':
            return Environment.prod;
        default:
            return Environment.localdev;
    }
};
  
export const GetEnvironmentConfig = (): EnvironmentConfig => {
    const environment: Environment = GetEnvironment();
    const authEndpoint: AuthEndpoint = authEndpointMap[environment];
    const frontendEnvironment: FrontendEnvironment = environmentMap[environment];
    const config: EnvironmentConfig = Object.assign(frontendEnvironment, { environment, authEndpoint });
    return config;
};
